module.exports = __webpack_public_path__ + "static/media/CDK-Circular-Logo.462c7268.png";